// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"40c36eeb","27":"4707623d","186":"3c5318fa","209":"dd9faf34","344":"fab93e8f","372":"bb90af77","377":"83532606","387":"4e518383","738":"63100539","841":"35ddfd41","856":"e314aded","891":"ac34bca9"}[chunkId] + ".chunk.js";
};